<template>
  <div class="institution">
    <el-row :gutter="20" class="searchRow">
      <el-col :span="22">
        <!-- 查询框区域 -->
        <el-form size="mini" :inline="true" label-width="90px">
          <el-form-item label="商户名称">
            <el-input
              clearable
              size="mini"
              v-model="institutionName"
              placeholder="请输入商户名称"
              style="width: 12vw"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="商户编码">
            <el-input
              clearable
              size="mini"
              v-model="institutionCode"
              placeholder="请输入商户编码"
              style="width: 12vw"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="创建时间">
            <el-date-picker
              v-model="createTime"
              type="daterange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width: 12vw"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="statu" placeholder="请选择" style="width: 12vw">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
      <!-- 提交按钮 -->
      <el-col :span="2" class="searchbuttons">
        <div>
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-search"
            @click="filterData"
            >查询</el-button
          >
        </div>
        <div class="searchButton">
          <el-button
            type="info"
            size="mini"
            icon="el-icon-refresh-right"
            @click="reset"
            >重置</el-button
          >
        </div>
      </el-col>
    </el-row>
    <!-- 新增按钮 -->
    <el-button
      v-if="addFlag"
      class="addInstitution"
      v-permission="'merchant_creat'"
      type="primary"
      size="mini"
      icon="el-icon-plus"
      @click="createInstitution"
      >新增</el-button
    >
    <!-- 表格区域 -->
    <el-table
      v-loading="loading"
      :data="tableData"
      :border="true"
      :cell-style="cell"
      class="institutionTable"
    >
      <el-table-column align="center" prop="name" label="商户名称" width="180">
        <template slot-scope="scope">
          <div
            @click="godetail(scope.row._id)"
            :style="{
              color: $jumpPerm('merchant_detail') ? '#165DFF' : '#606266',
              cursor: 'pointer',
            }"
          >
            {{ scope.row.name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="code" label="商户编码">
      </el-table-column>
      <el-table-column align="center" prop="type" label="商户类型">
      </el-table-column>
      <el-table-column align="center" prop="created" label="创建日期">
      </el-table-column>
      <el-table-column align="center" prop="status" label="状态">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            @change="handleStatuChange(scope.row._id, scope.row.status)"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column align="center" fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="goMerchant(scope.row._id)"
          >
            机构管理
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[5, 10, 20, 50]"
      :page-size="size"
      layout="->,sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import { businessLists, businessOptionEdit } from "@/api/institutionApi";
import { formatDate } from "@/utils/util.js";
export default {
  data() {
    return {
      // 商户名称
      institutionName: "",
      // 商户编码
      institutionCode: "",
      // 创建时间
      createTime: null,
      // 状态
      statu: "",
      options: [
        {
          value: 1,
          label: "启用",
        },
        {
          value: 2,
          label: "停用",
        },
      ],
      loading: "",
      // 表格数据
      tableData: [
        {
          name: "",
          code: "",
          type: "",
          created: "",
          status: null,
        },
      ],
      // 页码值
      page: 1,
      // 页码尺寸
      size: 10,
      // 总条数
      total: 0,
    };
  },
  computed: {
    addFlag() {
      //添加商户权限控制
      return (
        // this.$store.state.userInfo.permissions.includes("businessAdd") ||
        // this.$store.getters.isAdmin
        this.$store.state.userInfo.permissions.includes("merchant_creat") ||
        this.$store.getters.isAdmin
      );
    },
    editFlag() {
      // 编辑配置项权限
      return (
        this.$store.state.userInfo.permissions.includes(
          "businessEditConfigure"
        ) || this.$store.getters.isAdmin
      );
    },
    detailFlag() {
      // 查看商户详情权限
      return (
        this.$store.state.permissions.includes("merchant_detail") ||
        this.$store.getters.isAdmin
      );
      // return (
      //   this.$store.state.userInfo.permissions.includes("businessDetail") ||
      //   this.$store.getters.isAdmin
      // );
    },
  },
  created() {
    this.getbusiness();
  },
  methods: {
    // 设置表格第一列的文字颜色
    cell({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return "color:#165DFF";
      }
    },
    // 获取表格数据
    async getbusiness() {
      const { data } = await businessLists({
        page: this.page,
        size: this.size,
        name: this.institutionName,
        code: this.institutionCode,
        create_time: this.getCreateTime(),
        status: this.statu,
      });
      if (data.code === 1000) {
        this.total = data.data.count;
        this.tableData = data.data.list;
        this.tableData &&
          this.tableData.forEach(
            (item) => (item.status = item.status === 1 ? true : false)
          );
      } else {
        this.$message.error(data.msg);
      }
    },
    // 格式化创建时间字段
    getCreateTime() {
      if (this.createTime) {
        const start = formatDate(this.createTime[0], "YYYY-MM-DD HH:mm:ss");
        const endDate = new Date(this.createTime[1]);
        const year = endDate.getFullYear();
        const month = (endDate.getMonth() + 1).toString().padStart(2, "0");
        const day = endDate.getDate().toString().padStart(2, "0");
        const end = `${year}-${month}-${day} 23:59:59`;
        return `${start}~${end}`;
      }
      return "";
    },
    // 按条件查询表格
    filterData() {
      this.getbusiness();
    },
    // 修改商户状态
    async handleStatuChange(id, status) {
      // if (this.editFlag) {
      if (this.$jumpPerm("merchant_state_change")) {
        const { data } = await businessOptionEdit({
          _id: id,
          status: status ? 1 : 2,
        });
        if (data.code === 1000) {
          this.reset();
          this.getbusiness();
        } else {
          this.$message.error(data.msg);
        }
      } else {
        this.$message.error("您没有编辑商户状态的权限");
        this.getbusiness();
      }
    },
    // 重置按钮
    reset() {
      this.page = 1;
      this.institutionName = "";
      this.institutionCode = "";
      this.createTime = "";
      this.statu = "";
      this.getbusiness();
    },
    // 页码尺寸改变
    handleSizeChange(val) {
      this.size = val;
      this.getbusiness();
    },
    // 当前页改变
    handleCurrentChange(val) {
      this.page = val;
      this.getbusiness();
    },
    // 跳转新增商户页
    createInstitution() {
      this.$router.push("/newInstitution");
    },
    // 跳转商户详情
    godetail(id) {
      if (this.$jumpPerm("merchant_detail")) {
        this.$router.push({
          path: "/institutionDetail",
          query: { id: id },
        });
      }
      // if (this.detailFlag) {
      //   this.$router.push({
      //     path: "/institutionDetail",
      //     query: { id: id },
      //   });
      // }
    },
    // 跳转机构管理
    goMerchant(id) {
      if (this.$jumpPerm("organize_manage")) {
        this.$router.push({
          path: "/merchant",
          query: { id: id },
        });
      } else {
        this.$message({
          type: "error",
          message: "没有权限",
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.institution {
  box-sizing: border-box;
  height: 100% -30px;
  background-color: #fff;
  padding: 20px;
}
.searchRow {
  margin-bottom: 20px;
  border-bottom: 1px solid #ccc;
}
.searchButton {
  padding-top: 20px;
  padding-bottom: 20px;
}
.addInstitution {
  margin-bottom: 20px;
}
.institutionTable {
  width: 100%;
  margin-bottom: 20px;
}
</style>
